import React from 'react';
import PropTypes from 'prop-types';

import ToAnswer from '../../../shared/to-answer';

// import style from './index.module.scss';

const sortFunc = (a, b) => {
  a = a.answers.length;
  b = b.answers.length;

  return a < b ? -1 : a > b ? 1 : 0;
};

function WriteAnswers({ topicName, questionList }) {
  const sortedByLeastAnswered = [...questionList].sort(sortFunc);

  return (
    <>
      {sortedByLeastAnswered.map(question => (
        <div key={question.id}>
          <ToAnswer
            questionTitle={question.title}
            questionId={question.id}
            answersLength={question.answers.length}
            updatedAt={question.updatedAt}
          />
        </div>
      ))}
    </>
  );
}

WriteAnswers.propTypes = {
  topicName: PropTypes.string.isRequired,
  questionList: PropTypes.array.isRequired,
};

export default WriteAnswers;
